var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 11,
  r: 2.7,
  fill: "#3c4652"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.5,
  cy: 11,
  r: 2.7,
  fill: "#3c4652"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 33,
  r: 2.7,
  fill: "#3c4652"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.5,
  cy: 33,
  r: 2.7,
  fill: "#3c4652"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.5,
  cy: 22,
  r: 2.7,
  fill: "#3c4652"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 39.5,
  cy: 22,
  r: 2.7,
  fill: "#3c4652"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 22.5,
  cy: 22,
  rx: 13.5,
  ry: 8,
  fill: "#c8925a"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 22.5,
  cy: 22,
  rx: 10.5,
  ry: 5.6,
  fill: "#d99a3f"
});

function SvgConfRooms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfRooms);
export default __webpack_public_path__ + "static/media/conf-rooms.cb3372dd0d3d6cf014511078ddd85a85.svg";
export { ForwardRef as ReactComponent };